import View from "../../../../assets/js/view";
// import playerjs from 'player.js';
import VimeoPlayer from "@vimeo/player";
import YouTubePlayer from "youtube-player";
import { breakpoints } from "../../../../assets/js/config";

export default class FlexibleVideo extends View {
  ui = {
    iframe: "iframe[0]",
    youtube: ".js-youtube[0]",
  };

  events = {};

  init() {
    this.bind("obCallback");

    const type = (this.type = this.el.dataset.type);

    if (type == "youtube") {
      this.player = YouTubePlayer(this.ui.youtube);
      this.player.loadVideoById(this.el.dataset.youtube);
      this.player.stopVideo();
      if (window.innerWidth > breakpoints.xsmall) {
        this.player.mute();
      }
    } else if (type == "vimeo") {
      this.vimeo = new VimeoPlayer(this.ui.iframe);
      if (window.innerWidth > breakpoints.xsmall) {
        this.vimeo.setVolume(0);
      }
    }

    this.ob = new IntersectionObserver(this.obCallback);
    this.ob.observe(this.el);
  }

  obCallback([entry], observer) {
    if (entry.isIntersecting) {
      if (this.type == "youtube") {
        this.player.playVideo();
      } else if (this.type == "vimeo") {
        this.vimeo.play();
      }
      this.ob.unobserve(this.el);
    }
  }
}
